<template>
  <!-- The approval screen an AI send waits on (Workspace369 lib/view/mcp/approvals/
       mcp_approval_screen.dart, strings from app_en.arb). Beats: Claude's request lands, the
       pointer presses "Approve and send", the buttons give way to the done panel, and the
       "Approved by" line settles under the plan-tone ring. Sample data only. -->
  <div class="mcpa">
    <div class="mcpa-head fm-rise" style="--at: 0.08">
      <span class="mcpa-tile"><img src="/images/ai-connections/ai_logo_claude.svg" alt="" width="17" height="17" /></span>
      <div class="mcpa-head-copy">
        <p><span translate="no">Claude</span> is asking to do this in Studio North</p>
        <p class="mcpa-verified">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path :d="icons.verified" /></svg>
          <span>Verified: this is <span translate="no">Claude</span>.</span>
        </p>
      </div>
    </div>

    <p class="mcpa-headline fm-rise" style="--at: 0.15">Send invoice #1042 for Acme Co by email</p>

    <div class="mcpa-rows fm-rise" style="--at: 0.21">
      <span>To</span>
      <strong>billing@acme.test</strong>
    </div>

    <p class="mcpa-expiry fm-rise" style="--at: 0.25">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path :d="icons.schedule" /></svg>
      Expires in about 59 minutes
    </p>

    <div class="fm-stack mcpa-actions">
      <div class="mcpa-buttons fm-out" style="--at: 0.48">
        <span class="mcpa-btn mcpa-btn-primary fm-rise" style="--at: 0.28">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path :d="icons.check" /></svg>
          Approve and send
        </span>
        <span class="mcpa-btn mcpa-btn-secondary fm-rise" style="--at: 0.3">Decline</span>
      </div>

      <!-- The pointer sits on its own layer so its ripple outlives the buttons it presses. -->
      <div class="mcpa-cursor">
        <span class="fm-ripple" style="--press: 0.46"></span>
        <span class="fm-pointer" style="--press: 0.46">
          <svg viewBox="0 0 12 18" aria-hidden="true"><path d="M0 0 0 15 3.8 11.6 6.6 18 9.2 16.9 6.5 10.6 11.5 10.6Z" /></svg>
        </span>
      </div>

      <div class="mcpa-done">
        <div class="mcpa-panel fm-rise fm-focus" style="--at: 0.5; --grow: 3px; --radius: 12px">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path :d="icons.checkCircle" /></svg>
          Approved and done.
        </div>
        <p class="mcpa-by fm-rise" style="--at: 0.58">Approved by Maya Ortiz · just now</p>
      </div>
    </div>
  </div>
</template>

<script setup>
// Material icon paths (24x24) for the icons the app's approval screen uses.
const icons = {
  verified: 'M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z',
  schedule: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z',
  check: 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
  checkCircle: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
};
</script>

<style>
.mcpa { display: grid; gap: 0; }
.mcpa-head { display: flex; align-items: flex-start; gap: 10px; }
.mcpa-tile {
  display: grid;
  flex: none;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: var(--fm-sunken);
  box-shadow: inset 0 0 0 1px var(--fm-line);
}
.mcpa-tile img { width: 17px; height: 17px; }
.mcpa-head-copy p { margin: 0; color: var(--fm-text); font-size: 12.5px; font-weight: 500; }
.mcpa-head-copy .mcpa-verified {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
  color: var(--fm-muted);
  font-size: 11px;
  font-weight: 400;
}
.mcpa-verified svg { width: 13px; height: 13px; flex: none; fill: var(--fm-green); }
.mcpa-headline {
  margin: 14px 0 0;
  color: var(--fm-text);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.005em;
}
.mcpa-rows {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  border: 1px solid var(--fm-line);
  border-radius: 8px;
  padding: 8px 10px;
}
.mcpa-rows span { color: var(--fm-muted); }
.mcpa-rows strong { min-width: 0; overflow: hidden; color: var(--fm-text); font-weight: 500; text-overflow: ellipsis; white-space: nowrap; }
.mcpa-expiry {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 10px 0 0;
  color: var(--fm-muted);
  font-size: 11px;
}
.mcpa-expiry svg { width: 13px; height: 13px; flex: none; fill: currentColor; }
.mcpa-actions { margin-top: 14px; }
.mcpa-buttons { display: grid; gap: 6px; }
.mcpa-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 34px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 500;
}
.mcpa-btn svg { width: 15px; height: 15px; fill: currentColor; }
.mcpa-btn-primary { background: var(--fm-ink); color: var(--fm-ink-text); }
.mcpa-btn-secondary { border: 1px solid var(--fm-line); color: var(--fm-text); }
.mcpa-done { align-self: start; }
.mcpa-cursor { position: relative; z-index: 2; height: 34px; align-self: start; pointer-events: none; }
.mcpa-cursor .fm-pointer, .mcpa-cursor .fm-ripple { left: 64%; top: 17px; }
.mcpa-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  background: var(--fm-green-fill);
  padding: 11px 12px;
  color: var(--fm-text);
  font-weight: 600;
}
.mcpa-panel svg { width: 18px; height: 18px; flex: none; fill: var(--fm-green); }
.mcpa-by { margin: 8px 0 0; color: var(--fm-muted); font-size: 11px; }
</style>
